import React from "react";

import Routes from "../../routes/Smart";
import SidebarLayout from "../../layouts/Sidebar";

class Layout extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <SidebarLayout
        onSearch={() => {}}
        sidebarTitle="smart"
        navigationOptions={[
          
        ]}
      >
        <Routes
          api={this.props.api}
          user={this.props.user}
        />
      </SidebarLayout>
    );
  }
}

export default Layout;
